export default __webpack_public_path__ + "assets/images/4a235a56d29aa9b57b31c96121901223-officeImage.png";